module.exports = __webpack_public_path__ + "vg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/vg.svg
// module id = 1135
// module chunks = 0